<template>
  <div>
    <modal
      :isShow.sync="visible"
      :title="'请增加活动（选填）'"
      :isShowBtn="[false,false]"
      :width="'722px'"
    >
      <div class="content">
        <p>添加活动，方便您更好的追踪数据</p>
        <div class="select">
          <el-form label-width="80px">
            <el-form-item label="活动名称">
              <el-select v-model="activityCode" @onChange="handleChange" placeholder="请选择活动区域" clearable>
                <el-option v-for="item in (selectArray)" :key="item.activityCode" :value="item.activityCode" :label="item.activityName"></el-option>
                <hr style="border-top: 1px #ddd dashed;" />
                <el-button type="text" size="mini" style="margin-left: 15px;" @click="showDialog">添加新活动</el-button>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="contentButton">
          <el-button type="primary" @click="getOnlineLink" size="small">复制链接</el-button>
        </div>
      </div>
    </modal>
    <modal
      :isShow.sync="dialogVisible"
      :title="'添加活动'"
      :isShowBtn="[false,false]"
      :width="'722px'"
    >
      <div class="content">
        <el-form ref="form" :model="form" label-width="80px" size="small">
          <el-form-item
            label="活动名称"
            :rules="[
              { required: true, message: '活动名称不能为空'},
            ]"
          >
            <el-input v-model="form.activityName"></el-input>
          </el-form-item>
          <el-form-item label="活动备注">
            <el-input type="textarea" v-model="form.activityDesc"></el-input>
          </el-form-item>
          <el-form-item
            label="页面模版"
            :rules="[
              { required: true, message: '页面模版不能为空'},
            ]"
          >
            <el-col :span="11">
              <el-select v-model="form.pageTemplateCode" @change="changePage" placeholder="请选择页面模版" clearable>
                <el-option v-for="item in (pageTemplates)" :key="item.pageTempalteCode" :value="item.pageTempalteCode" :label="item.pageTempalteName"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="活动时间">
            <el-date-picker
              v-model="form.time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">立即创建</el-button>
            <el-button @click="onCancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </modal>
  </div>
</template>

<script>
import modal from "@/components/modal";
import { copyUrl } from "@/utils/tools";
import { pageQueryActivity, queryPageTemplate, addActivity, batchBindingContent } from "@/api/contentDistribution";
import utils from "../../utils";
import { getOnlineLinksAsync } from "../../entrys/man/pages/contentManage/distribution";

export default {
  name: "ActiveModal",
  props: ['dialogPreVisible', 'dialogData'],
  computed: {
    visible: {
      get() {
        return this.dialogPreVisible
      },
      set(val) {
        this.$emit('update:dialogPreVisible',val)
      }
    },
    url: {
      get() {
        return this.mUrl
      },
      set(val) {
        this.$emit('update:mUrl',val)
      }
    }
  },
  data() {
    return {
      form: {
        activityName: '',
        activityDesc: '',
        startTime: '',
        endTime: '',
        pageTemplateCode:'',
      },
      selectArray: [],
      value: [],
      dialogVisible: false,
      pageTemplates: [],
      mUrl: '',
      activityCode: '',
    }
  },
  created() {
    this.initData();
  },
  methods: {
    changePage(e) {
      this.form.pageTemplateCode = e;
    },
    // 绑定活动操作
    batchBindingContent() {
      return new Promise((resolve, reject) => {
        batchBindingContent({
          tenantId: this.$route.query.tenantid,
          source: 'content',
          activityCode: this.activityCode,
          contentIds: [this.dialogData.id],
          appid: 'content-marketing',
        }).then((res) => {
          if (res) {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },
    // 获取线上链接并复制
    async getOnlineLink() {
      this.mUrl = await getOnlineLinksAsync(this.dialogData, true, this);
      if (!this.activityCode) {
        copyUrl(`${this.mUrl}`, this);
        return;
      }
      const bindSuccess = await this.batchBindingContent();
      if (bindSuccess) {
        copyUrl(`${this.mUrl}?activityCode=${this.activityCode}`, this);
      } else {
        this.$message.error('绑定活动失败，请重试');
      }
    },
    time(data) {
      if (data) {
        return utils.timetamp(data);
      }
    },
    onCancel() {
      this.dialogVisible = false;
      this.$emit('update:dialogPreVisible', true)
    },
    onSubmit() {
      const { time } = this.form;
      if (time) {
        this.form.startTime = this.time(time[0]);
        this.form.endTime = this.time(time[1]);
        // delete this.form.time;
      }
      if (!this.form.activityName) {
        this.$message.error('请填写活动名称');
        return;
      }
      console.log(this.form.pageTemplateCode);
      if (!this.form.pageTemplateCode) {
        this.$message.error('请选择页面模版');
        return;
      }
      const { time: _, ...otherParam } = this.form;
      // return;
      addActivity({
        tenantId: this.$route.query.tenantid,
        source: 'content',
        // contentForm: this.dialogData.articleType,
        ...otherParam,
      }).then((res) => {
        if (res) {
          this.$message.success('添加成功!');
          this.initData();
          this.dialogVisible = false;
          this.$emit('update:dialogPreVisible', true)
        } else {
          this.$message.error('添加失败!');
        }
      })
    },
    showDialog() {
      this.dialogVisible = true;
        this.$emit('update:dialogPreVisible', false)
    },
    handleChange(e) {
      this.activityCode = e;
    },
    initData () {
      pageQueryActivity({
        tenantId: this.$route.query.tenantid,
        source: 'content',
        pageNo: 1,
        pageSize: 500,
      }).then((res) => {
        this.selectArray = res.data || [];
      });
      queryPageTemplate({
        tenantId: this.$route.query.tenantid,
        isOneSelf: false,
        source: 'content',
        pageSize: 100,
        pageNo: 1,
        pageTempalteStatus: 1,
      }).then((res) => {
        this.pageTemplates = res.data;
      });
    }
  },
  components: {
    modal
  }
}
</script>

<style lang="scss" scoped>

.content {
  padding: 26px 25px 18px 26px;
  p {
    font-size: 16px;
  }
  .select {
    margin-top: 15px;
  }
  .contentButton {
    display: flex;
    justify-content: center;
  }
}

.image {
  margin-top: 20px;

  .dialog-input {
    width: 558px;
  }

  .dislog-sub-title {
    color: #8b8c9a;
    font-size: 12px;
    margin-top: 14px;
  }

  .color {
    margin-left: 24px;
  }

  .qrCode {
    width: 182px;
    height: 182px;
    margin: 60px auto;
    margin-bottom: 0px;
  }

  .img-des {
    margin: 0 auto;
    width: 182px;
    text-align: center;
  }
}
</style>
